export enum RouteName {
  ACTUALITES = 'actualites',
  ACTUALITES_SINGLE = 'actualites-single',
  CLIENTS = 'clients',
  CLIENTS_SINGLE = 'clients-single',
  CLIENTS_SINGLE_CONTRATS = 'clients-single-contrats',
  CLIENTS_SINGLE_DOCUMENTS = 'clients-single-documents',
  COMPTE_EDIT = 'compte-edit',
  COMPTE_EDIT_NOTIFICATIONS = 'compte-edit-notifications',
  CONTACTS = 'contacts',
  CONTRATS = 'contrats',
  CONTRATS_SINGLE = 'contrats-single',
  CONTRATS_SINGLE_ASSURES = 'contrats-single-assures',
  CONTRATS_SINGLE_COMMISSIONS = 'contrats-single-commissions',
  CONTRATS_SINGLE_DOCUMENTS = 'contrats-single-documents',
  CONTRATS_SINGLE_SYNTHESE = 'contrats-single-synthese',
  CONDITIONS_GENERALES_UTILISATION = 'conditions-generales-utilisation',
  CONDITIONS_GENERALES_UTILISATION_ACCEPTER = 'conditions-generales-utilisation-accepter',
  COORDONNEES_PARTENAIRE = 'informations-partenaires',
  DOCUMENTATION = 'documentation',
  DOCUMENTATION_DOWNLOAD = 'documentation-download',
  DOCUMENTATION_SEARCH = 'documentation-search',
  ERROR = 'error',
  ERROR_ACCESS_DENIED = 'error-forbidden',
  ERROR_NOT_FOUND = 'error-not-found',
  HOME = 'home',
  LOGOUT = 'logout',
  MENTIONS_LEGALES = 'mentions-legales',
  OFFRES = 'offres',
  OFFRES_COMPARATEUR_EMPRUNTEUR = 'offres-comparateur-emprunteur',
  PROJETS = 'projets',
  REGLEMENTAIRE_TRAITEMENT_RECLAMATIONS = 'reglementaire-traitement-reclamations',
  REMUNERATIONS = 'remunerations',
  REMUNERATIONS_BORDEREAUX = 'remunerations-bordereaux',
  REMUNERATIONS_BORDEREAUX_EMPRUNTEUR = 'remunerations-bordereaux-emprunteur',
  REMUNERATIONS_COMPLEMENTAIRES = 'remunerations-complementaires',
  REMUNERATIONS_ESCOMPTES = 'remunerations-escomptes',
  REMUNERATIONS_SYNTHESE = 'remunerations-synthese',
  UTILISATEURS = 'utilisateurs',
  UTILISATEURS_PARAMETRES = 'utilisateurs-parametres',
  UTILISATEURS_SINGLE_ADD = 'utilisateurs-single-add',
  UTILISATEURS_SINGLE_ASSOCIER = 'utilisateurs-single-associer',
  UTILISATEURS_SINGLE_EDIT = 'utilisateurs-single-edit',
  UTILISATEURS_SINGLE_EDIT_NOTIFICATIONS = 'utilisateurs-single-edit-notifications',
}
